/**
 * Limpeza de caches ao trocar de conta (mesma aba / login sem logout completo).
 * Não remove theme, locale nem inviteToken.
 */

export const LAST_SESSION_USER_ID_KEY = 'backlog_last_session_user_id'

const LOCAL_STORAGE_PREFIXES = ['workspace-last-route-', 'workspace-order-']
const LOCAL_STORAGE_EXACT_KEYS = ['currentWorkspace']

export function getLastSessionUserId() {
  if (typeof localStorage === 'undefined') return null
  const raw = localStorage.getItem(LAST_SESSION_USER_ID_KEY)
  return raw != null && raw !== '' ? raw : null
}

export function setLastSessionUserId(userId) {
  if (typeof localStorage === 'undefined' || userId == null) return
  localStorage.setItem(LAST_SESSION_USER_ID_KEY, String(userId))
}

export function parseUserIdFromStorage() {
  if (typeof localStorage === 'undefined') return null
  try {
    const raw = localStorage.getItem('user')
    if (!raw) return null
    const parsed = JSON.parse(raw)
    const id = parsed?.id
    return id != null ? id : null
  } catch {
    return null
  }
}

export function isDifferentUser(previousId, nextId) {
  if (nextId == null) return false
  if (previousId == null) return false
  return String(previousId) !== String(nextId)
}

export function clearUserScopedLocalStorage() {
  if (typeof localStorage === 'undefined') return
  const keysToRemove = []
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i)
    if (!key) continue
    if (LOCAL_STORAGE_EXACT_KEYS.includes(key)) {
      keysToRemove.push(key)
      continue
    }
    if (LOCAL_STORAGE_PREFIXES.some((prefix) => key.startsWith(prefix))) {
      keysToRemove.push(key)
    }
  }
  keysToRemove.forEach((key) => localStorage.removeItem(key))
}

/** @deprecated use clearUserScopedLocalStorage — alias para rotas de workspace */
export function clearWorkspaceLastRouteCache() {
  clearUserScopedLocalStorage()
}

export async function clearAppCachesOnUserChange() {
  clearUserScopedLocalStorage()

  const [
    { resetGlobalWorkspacesState },
    { clearWorkspaceRoleCaches },
    { invalidatePlanoFeaturesCache },
    { clearPermissionsCache },
    { useWorkspaceStore }
  ] = await Promise.all([
    import('../composables/useGlobalWorkspaces.js'),
    import('../composables/useWorkspaceAccess.js'),
    import('../composables/usePlanoFeatures.js'),
    import('../router/index.js'),
    import('../stores/workspace.js')
  ])

  resetGlobalWorkspacesState()
  clearWorkspaceRoleCaches()
  invalidatePlanoFeaturesCache()
  clearPermissionsCache()
  useWorkspaceStore().clearSession()
}

export async function handleUserSessionChange(nextUserId) {
  const previousId = getLastSessionUserId() ?? parseUserIdFromStorage()
  if (isDifferentUser(previousId, nextUserId)) {
    await clearAppCachesOnUserChange()
  }
  if (nextUserId != null) {
    setLastSessionUserId(nextUserId)
  }
}

export async function clearSessionCompletely() {
  await clearAppCachesOnUserChange()
  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem(LAST_SESSION_USER_ID_KEY)
  }
}

export function reloadWorkspacesAfterAuth() {
  import('../composables/useGlobalWorkspaces.js').then(({ useGlobalWorkspaces }) => {
    useGlobalWorkspaces().loadWorkspaces(true)
  })
}
